import { DEFAULT_LOCALE, Locale } from "@/i18n/types";
import { isValidLocale } from "@/i18n/utils";

const LOCAL_STORAGE_KEYS = {
  currentLocale: "currentLocale",
};

export function getCurrentLocale(): Locale {
  const storedValue = localStorage.getItem(LOCAL_STORAGE_KEYS.currentLocale);
  if (storedValue && isValidLocale(storedValue)) {
    return storedValue;
  }

  return DEFAULT_LOCALE;
}

export function saveLocale(locale: string) {
  return localStorage.setItem(LOCAL_STORAGE_KEYS.currentLocale, locale);
}
